import { useEffect, useRef, useState } from "react";
import { Phone, X } from "lucide-react";

const WHATSAPP_LINK = "https://wa.me/917433881781?text=Hi%20👋%20Need%20Help?";

// Support lines revealed by the call button; tapping one opens the dialer.
const CALL_NUMBERS = ["8980319382", "9825929703"];

const WhatsAppButton = () => {
  const [showNumbers, setShowNumbers] = useState(false);
  const containerRef = useRef(null);

  // Collapse back to the call button when the user taps anywhere else.
  useEffect(() => {
    if (!showNumbers) return;
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowNumbers(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, [showNumbers]);

  return (
    <div
      ref={containerRef}
      className="fixed bottom-3 right-3 sm:bottom-5 sm:right-5 z-[1000] flex flex-col items-end gap-2"
    >
      {showNumbers &&
        CALL_NUMBERS.map((number) => (
          <a
            key={number}
            href={`tel:+91${number}`}
            onClick={() => setShowNumbers(false)}
            className="flex items-center gap-1.5 rounded-full bg-white px-3 py-2 text-sm font-semibold text-primary shadow-md border border-primary/20 transition-transform hover:scale-105"
          >
            <Phone size={14} />
            {number}
          </a>
        ))}
      <button
        type="button"
        onClick={() => setShowNumbers((prev) => !prev)}
        aria-label={showNumbers ? "Hide call numbers" : "Call us"}
        aria-expanded={showNumbers}
        className="flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full bg-primary text-white shadow-md transition-transform hover:scale-110"
      >
        {showNumbers ? <X size={22} /> : <Phone size={22} />}
      </button>
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full bg-[#e6f0ff] shadow-md transition-transform hover:scale-110"
      >
        <img src="/image/image 43.png" alt="WhatsApp Icon" className="h-6 w-6 sm:h-7 sm:w-7" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
